module.exports = __webpack_public_path__ + "static/media/clock-white.fc415f15.svg";